/* eslint-disable no-param-reassign */
// TODO: refactor this file so it stops mutating the "group" object

import React, { Fragment, useEffect, useState } from 'react';
import { produce } from 'immer';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { MobileSelectionItem } from './MobileSelectionItem';
import { Colors } from '../../../../play-core/styles/Colors';
import { equals } from '../../../../play-core/utils/array-helper';
import { MobileDialogButton } from '../MobileDialog/MobileDialogButton';
import { useMobileDialogDispatch } from '../MobileDialog/MobileDialogContext';
import { MobileDialogHeader } from '../MobileDialog/MobileDialogHeader';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MobileGroupedSelection = ({
  title,
  saveButtonText,
  isLoading,
  groups,
  onChange
}) => {
  const {
    t
  } = useTranslation();
  const [editingGroups, setEditingGroups] = useState(groups);
  const mobileDialogDispatch = useMobileDialogDispatch();
  useEffect(() => setEditingGroups(groups), [groups]);
  const isSelected = (groupIndex, itemId) => editingGroups[groupIndex].selectedItems.includes(itemId);
  const toggleItem = (groupIndex, itemId) => {
    const newGroups = produce(editingGroups, draftGroups => {
      const group = draftGroups[groupIndex];
      if (group.selectedItems.includes(itemId)) {
        group.selectedItems = group.selectedItems.filter(item => item !== itemId);
      } else if (group.singleSelection) {
        group.selectedItems = [itemId];
      } else {
        group.selectedItems.push(itemId);
      }
    });
    setEditingGroups(newGroups);
  };
  const hasChanges = groups.some((group, groupIndex) => {
    const editingGroup = editingGroups[groupIndex];
    if (editingGroup) {
      return !equals(group.selectedItems, editingGroup.selectedItems);
    }
    return false;
  });
  const hasSelection = editingGroups.some(group => group.selectedItems.length > 0);
  const onSave = () => hasChanges && onChange(editingGroups);
  const resetAll = () => {
    const newGroups = produce(editingGroups, draftGroups => {
      draftGroups.forEach(group => {
        group.selectedItems = [];
      });
    });
    setEditingGroups(newGroups);
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MobileDialogHeader, {
      closeIcon: "back",
      title: title,
      actionVisible: hasSelection,
      actionText: t('global.reset'),
      onAction: resetAll,
      onClose: onSave,
      isLoading: isLoading
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(List, {
        children: editingGroups.map((group, groupIndex) => /*#__PURE__*/_jsxs(Fragment, {
          children: [group.items.map(item => /*#__PURE__*/_jsx(MobileSelectionItem, {
            item: item,
            isSelected: isSelected(groupIndex, item.id),
            onToggle: () => toggleItem(groupIndex, item.id)
          }, `${group.id}-${item.id}`)), groupIndex < groups.length - 1 && /*#__PURE__*/_jsx(Separator, {})]
        }, group.id))
      })
    }), /*#__PURE__*/_jsx(MobileDialogButton, {
      text: saveButtonText,
      onClick: () => {
        onSave();
        mobileDialogDispatch({
          type: 'close-all'
        });
      }
    })]
  });
};
const Container = styled.div.withConfig({
  displayName: "MobileGroupedSelection__Container",
  componentId: "sc-cylocv-0"
})(["background-color:", ";height:100%;width:100%;display:flex;flex-direction:column;"], Colors.GREY_1a1a1a);
const List = styled.ul.withConfig({
  displayName: "MobileGroupedSelection__List",
  componentId: "sc-cylocv-1"
})(["margin:0;padding:0;height:100%;overflow-y:auto;-webkit-overflow-scrolling:touch;"]);
const Separator = styled.div.withConfig({
  displayName: "MobileGroupedSelection__Separator",
  componentId: "sc-cylocv-2"
})(["height:1px;background-color:", ";margin:8px 0 8px 24px;"], Colors.GREY_454545);